import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { Provider } from "react-redux";

import App from "../App";
import Minting from "../pages/Minting";
import store from "../redux/store";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Terms from "../pages/Terms";
import ScrollToTop from "../components/ScrollToTop";

const Routing = () => {
  return (
    <Router>
      <Provider store={store}>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route exact path="*" element={<Navigate to="/" />} />
          <Route exact path="/" element={<App />} />
          <Route exact path="/purchase" element={<Minting />} />
          <Route exact path="/terms" element={<Terms />} />
        </Routes>
        <Footer />
      </Provider>
    </Router>
  );
};

export default Routing;
